export default "__VITE_ASSET__e8963e5f__"